import { usePage } from '@inertiajs/vue3';
import type { User } from '@/types/models';

const page = usePage<{
    auth: {
        user: User;
    };
}>();
function getCurrentUserId() {
    return page.props.auth.user.id;
}

function getCurrentUser() {
    return page.props.auth.user;
}

function getCurrentOrganizationId() {
    return page.props.auth.user.current_team_id;
}

function getCurrentMembershipId() {
    return page.props.auth.user.all_teams.find((team) => team.id === getCurrentOrganizationId())
        ?.membership.id;
}

function getCurrentRole() {
    return page.props.auth.user.all_teams.find((team) => team.id === getCurrentOrganizationId())
        ?.membership.role;
}

/**
 * netdev : ce membre peut-il faire tourner plusieurs minuteurs en même temps ?
 * Réglé par le propriétaire, membre par membre. Absent = comportement d'origine.
 */
function canRunConcurrentTimers() {
    return (
        page.props.auth.user.all_teams.find((team) => team.id === getCurrentOrganizationId())
            ?.membership.allow_concurrent_timers === true
    );
}

export {
    getCurrentOrganizationId,
    getCurrentUserId,
    getCurrentMembershipId,
    getCurrentRole,
    getCurrentUser,
    canRunConcurrentTimers,
};
